import { Directive, forwardRef } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, Validator } from "@angular/forms";

import { OBG_VALIDATORS, PasswordStrengthValidityType } from "../validators/validators";

@Directive({
	selector: "[obgPasswordStrength]",
	providers: [
		{
			provide: NG_VALIDATORS,
			// eslint-disable-next-line @angular-eslint/no-forward-ref
			useExisting: forwardRef(() => PasswordStrengthValidatorDirective),
			multi: true,
		},
	],
})
export class PasswordStrengthValidatorDirective implements Validator {
	validate(control: AbstractControl): PasswordStrengthValidityType {
		return OBG_VALIDATORS.passwordStrength(control);
	}
}
